import { ThemedButton } from "Components/Themes/components/ThemedButton";
import styled from "styled-components";

export const StyledButton = styled.button`
  background-color: inherit;
  border: none;
  color: ${({ theme }) => theme.brandColors.primary};
  cursor: pointer;
  display: block;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.md};
  padding: 32px 24px 48px;
  text-align: left;
  text-decoration: underline;

  &:disabled {
    cursor: not-allowed;
  }

  &:hover:enabled {
    text-decoration: none;
  }
`;

export const StyledBankIdButton = styled(ThemedButton)`
  & + button {
    margin-bottom: 24px;
  }

  margin-bottom: 8px;
`;

export const StyledIngress = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeight.md};
  line-height: ${({ theme }) => theme.lineHeight.md};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const StyledInlineButton = styled(StyledButton)`
  display: inline;
`;
